import styled from 'styled-components';
import { InputMask } from 'components/primitives/input-mask-new';

export const InputMaskCustomComponent = styled(InputMask)`
  height: 56px;
`;
